import { EntityFields } from './entity';
import { EntityType } from './entity-type';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, WriteResponse, Response } from './response';
export enum WidgetLayoutFields {
  Key = EntityFields.Key,
  Name = 'Name',
  EntityType = 'EntityType',
  CreationDate = 'CreationDate',
  Widgets = 'Widgets',
}

export interface WidgetLayout {
  [WidgetLayoutFields.Key]: string | null;
  [WidgetLayoutFields.Name]: string;
  [WidgetLayoutFields.EntityType]: EntityType;
  [WidgetLayoutFields.CreationDate]: Date;
  [WidgetLayoutFields.Widgets]: string;
}

export interface WidgetLayoutReadRequest extends Request {
  WidgetLayout: ReadRequest<WidgetLayout>;
}

export interface WidgetLayoutWriteRequest extends Request {
  WidgetLayout: WriteRequest<WidgetLayout>;
}

export interface WidgetLayoutResponse extends Response {
  WidgetLayout: DataResponse<WidgetLayout>;
}

export interface WidgetLayoutWriteResponse extends Response {
  WidgetLayout: WriteResponse<WidgetLayout>;
}
